import { render, staticRenderFns } from "./Grammar.vue?vue&type=template&id=2532cd48&scoped=true&"
import script from "./Grammar.vue?vue&type=script&lang=ts&"
export * from "./Grammar.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2532cd48",
  null
  
)

export default component.exports